"use client";

import { Award, Cog, Diamond, Gem, Plus } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GarantADeExcelenciaMDica() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const marks = [{
    icon: Cog,
    top: "CLÍNICA",
    bottom: "Medicina Avanzada"
  }, {
    icon: Diamond,
    top: "PRECISIÓN",
    bottom: "Resultados Naturales"
  }, {
    icon: Gem,
    top: "PERSONALIZACIÓN",
    bottom: "Atención Privada"
  }, {
    icon: Plus,
    top: "CIENCIA",
    bottom: "Protocolos Médicos"
  }, {
    icon: Award,
    top: "GARANTÍA",
    bottom: "Excelencia Capilar"
  }];
  return <section data-section-id="5040" id="garantía-de-excelencia-médica" className="text-foreground bg-muted dark ![padding:60px_32px_64px_32px]">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        {}
        <div className="h-px w-full" style={{
        backgroundColor: "hsl(38 48% 61% / 0.2)"
      }} />

        {}
        <div className="hidden md:flex items-center justify-between py-12 lg:py-14">
          {marks.map((mark, i) => {
          const Icon = mark.icon;
          return <div key={i} data-index={i} className="flex items-center flex-1">
                <div className="flex flex-col items-center text-center flex-1 opacity-70 hover:opacity-100 transition-opacity duration-200 px-2">
                  <img src="https://msinstitutocapilar.com/wp-content/uploads/2026/07/excelencia.png" className="w-6 h-6 mb-5 text-primary" />
                  <span className="font-default uppercase mb-2 text-primary !font-bold !text-base" style={{
                letterSpacing: "0.2em"
              }}>
                    {mark.top}
                  </span>
                  <span className="font-default text-foreground tracking-wide !text-sm !font-medium">
                    {mark.bottom}
                  </span>
                </div>
                {i < marks.length - 1 && <div className="h-6 w-px shrink-0" style={{
              backgroundColor: "hsl(38 48% 61% / 0.2)"
            }} />}
              </div>;
        })}
        </div>

        {}
        <div className="md:hidden relative py-10">
          <div className="overflow-x-auto scrollbar-none">
            <div className="flex items-center gap-8 px-4 min-w-max">
              {marks.map((mark, i) => {
              const Icon = mark.icon;
              return <div key={i} data-index={i} className="flex items-center gap-8">
                    <div className="flex flex-col items-center text-center opacity-70 hover:opacity-100 transition-opacity duration-200 min-w-[120px]">
                      <Icon className="w-5 h-5 mb-4 text-primary" strokeWidth={1} />
                      <span className="font-default text-[10px] uppercase mb-2 text-primary" style={{
                    letterSpacing: "0.2em"
                  }}>
                        {mark.top}
                      </span>
                      <span className="font-default text-xs text-foreground tracking-wide whitespace-nowrap">
                        {mark.bottom}
                      </span>
                    </div>
                    {i < marks.length - 1 && <div className="h-6 w-px shrink-0" style={{
                  backgroundColor: "hsl(38 48% 61% / 0.2)"
                }} />}
                  </div>;
            })}
            </div>
          </div>
          {}
          <div className="pointer-events-none absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-background to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-background to-transparent" />
        </div>

        {}
        <div className="h-px w-full" style={{
        backgroundColor: "hsl(38 48% 61% / 0.2)"
      }} />
      </div>
    </section>;
}